import React from 'react'

const SorContext = React.createContext();

export const SorDataProvider = SorContext.Provider;
export const SorDataConsumer = SorContext.Consumer;


export default SorContext;
